import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise = null;

/**
 * Inicializa o FingerprintJS de forma lazy
 * @returns {Promise} Promise do FingerprintJS agent
 */
const initFingerprint = () => {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }
  return fpPromise;
};

/**
 * Obtém o fingerprint do dispositivo atual
 * @returns {Promise<string>} Fingerprint único do dispositivo
 */
export const getFingerprint = async () => {
  try {
    const fp = await initFingerprint();
    const result = await fp.get();
    return result.visitorId;
  } catch (error) {
    console.error('Erro ao obter fingerprint:', error);
    // Fallback: gerar um ID baseado em localStorage se fingerprint falhar
    let fallbackId = localStorage.getItem('device_fallback_id');
    if (!fallbackId) {
      fallbackId = 'fallback_' + Math.random().toString(36).substring(2, 15);
      localStorage.setItem('device_fallback_id', fallbackId);
    }
    return fallbackId;
  }
};

/**
 * Obtém informações básicas do dispositivo para nomear
 * @returns {string} Nome amigável do dispositivo
 */
export const getDeviceName = () => {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform || 'Unknown';

  // Detectar navegador
  let browser = 'Unknown Browser';
  if (userAgent.includes('Firefox')) {
    browser = 'Firefox';
  } else if (userAgent.includes('Edg')) {
    browser = 'Edge';
  } else if (userAgent.includes('Chrome')) {
    browser = 'Chrome';
  } else if (userAgent.includes('Safari')) {
    browser = 'Safari';
  }

  // Detectar sistema operacional
  let os = 'Unknown OS';
  if (userAgent.includes('Windows')) {
    os = 'Windows';
  } else if (userAgent.includes('Mac OS')) {
    os = 'macOS';
  } else if (userAgent.includes('Linux')) {
    os = 'Linux';
  } else if (userAgent.includes('Android')) {
    os = 'Android';
  } else if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
    os = 'iOS';
  }

  return `${browser} em ${os}`;
};

export default {
  getFingerprint,
  getDeviceName
};
